/**
 * Kaysou Assist — estado puro dos chamados de mesa (cliente).
 *
 * Funções sem I/O: recebem o chamado devolvido pelo servidor e decidem
 * o que o cliente vê. Todos os textos de cliente estão em espanhol.
 */

export const ASSIST_TYPES = ["waiter", "bill"];
export const ACTIVE_ASSIST_STATUSES = ["new", "accepted"];

const LABELS = {
  waiter: {
    idle: "LLAMAR AL CAMARERO",
    new: "Camarero avisado.",
    accepted: "Un camarero ya está en camino.",
    completed: "Atención completada.",
  },
  bill: {
    idle: "PEDIR LA CUENTA",
    new: "Hemos avisado al equipo para preparar tu cuenta.",
    accepted: "Un camarero ya está en camino.",
    completed: "Atención completada.",
  },
};

/** true enquanto houver chamado pendente ou aceite — bloqueia repetições. */
export function isAssistLocked(request) {
  return !!request && ACTIVE_ASSIST_STATUSES.includes(request.status);
}

/** "idle" | "new" | "accepted" | "completed" — dirige cor e texto do botão. */
export function assistTone(request) {
  const status = request?.status;
  if (status === "new" || status === "accepted" || status === "completed") return status;
  return "idle";
}

/** Mensagem que o cliente vê para este tipo de chamado. */
export function assistLabel(type, request) {
  const table = LABELS[type];
  if (!table) return "";
  return table[assistTone(request)] || table.idle;
}

/** Chave de dispensa do Hub, por sessão (ou por mesa quando não há sessão). */
export function hubDismissKey(tableId, sessionId) {
  return `kaiso_table_hub_dismissed_${tableId || "-"}_${sessionId || "-"}`;
}

/**
 * O Hub abre em qualquer leitura válida de QR/NFC de mesa — NÃO exige que
 * já exista sessão. Na primeira leitura fica atrás do modal atual de
 * nome/telefone/pessoas/consentimento (por isso `sessionModalOpen` o
 * suprime) e aparece assim que esse modal termina. Fecha-se apenas
 * quando o cliente escolhe "PEDIR EN LA MESA".
 */
export function shouldOpenHub({ isTableOrder, tableId, dismissed, sessionModalOpen }) {
  return !!(isTableOrder && tableId && !sessionModalOpen && !dismissed);
}
